import { FlexyLayoutState } from './store';

export const customizerSelector = (s: FlexyLayoutState) => s.customizer;
